"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { cx } from "@/lib/tailwind-utils";
import { HorizontalToolbarButtons, InsertVariableBar } from "./toolbar/components";
export function Toolbar(t0) {
  const $ = _c(9);
  const {
    className,
    rightSlot
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex w-full items-center justify-center px-1 py-0.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center min-w-0 overflow-hidden"><HorizontalToolbarButtons /></div>;
    t3 = <InsertVariableBar />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== rightSlot) {
    t4 = rightSlot && <><div className="flex-1" />{rightSlot}</>;
    $[4] = rightSlot;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}